<div class="container contract-form-container">
    <form #form="ngForm" class="form container-fluid pl-0 pr-0">
        <div class="hero-text" style="margin-left: 10px;">
            <h1 style="font-weight: 800;">{{'ADD_CONTRACT'|translate}}</h1>
        </div>
        <div>
            <div class="px-20">
                <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'START_DATE'|translate}}</mat-label>
                    <input matInput [matDatepicker]="pickerstart" name="StartTime" [(ngModel)]="model.startDate"
                        required>
                    <mat-datepicker-toggle matSuffix [for]="pickerstart"></mat-datepicker-toggle>
                    <mat-datepicker name="startTimePicker" #pickerstart></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="px-20">
                <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'END_DATE'|translate}}</mat-label>
                    <input matInput [matDatepicker]="pickerend" name="EndTime" [(ngModel)]="model.endDate" required>
                    <mat-datepicker-toggle matSuffix [for]="pickerend"></mat-datepicker-toggle>
                    <mat-datepicker name="EndTimePicker" #pickerend></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="px-20">
                <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'DESCRIPTION'|translate}}</mat-label>
                    <input matInput placeholder="Description" name="description" [(ngModel)]="model.description"
                        required>
                </mat-form-field>
            </div>
            <div class="p-20">
                <mat-checkbox name="updateCheckbox" [(ngModel)]="model.status">{{'CONTRACT_STATUS'|translate}} :
                    {{model.status?("ACTIVE"|translate):("PASSIVE"|translate)}}</mat-checkbox>
            </div>
            <div class="py-20">
                <form enctype="multipart/form-data">
                    <input (change)="fileChange($event.target.files)" accept=".docx,.doc,.txt,.pdf,.jpeg,.jpg,.png"
                        type="file" placeholder="{{'CONTRACT_FILE'|translate}}">
                </form>
            </div>
        </div>
        <div class="p-20">
            <button mat-raised-button (click)="save()">
                <span>{{'CREATE'|translate}}</span>
            </button>
        </div>
    </form>
</div>